import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_PAYMENT_OPTIONS } from '@/api/endpoints';
import { PAYMENT_OPTIONS_QUERY_KEY } from '@/api/queryKeys';
import { PaymentOptionType } from '@/types/components';
import type { PaymentOption, PaymentOptionResponse } from '@/types/components';
import { unwrapAxiosResponse } from '@/utils/axios';

const toPaymentOption = ({
  periodName,
  description,
  ...option
}: PaymentOptionResponse): PaymentOption => ({
  ...option,
  subtitle:
    option.type === PaymentOptionType.Recurring ? description : periodName,
});

export const usePaymentOptions = () =>
  useQuery<PaymentOptionResponse[], Error, PaymentOption[]>({
    queryKey: PAYMENT_OPTIONS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<PaymentOptionResponse[]>(API_PAYMENT_OPTIONS)
        .then(unwrapAxiosResponse),
    select: (options) => options.map(toPaymentOption),
  });
